export default {
  meta: {
    title: '慢闪业务绩效报表导出',
    parentPath: ['/slowPopUp'],
    breadcrumbs: {
      path: ['/slowPopUp/slowPopUpReportConfiguration'],
      name: ['慢闪业务绩效报表导出'],
    },
  },
};
